/* eslint-disable react/prop-types */
import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../AuthProvider'

const ProtectedRoute = ({ children }) => {
  const { user, apiSessionIsOn } = useAuth()

  if (!user || !apiSessionIsOn()) {
    return <Navigate to="/login" />
  }

  return children
}

export default ProtectedRoute
